import { WalkthroughPrintDocument } from "@/components/walkthrough/walkthrough-print-document";
import type { WalkthroughFinding } from "./workspace-types";

interface WorkspacePrintDocumentProps {
  walkthrough: any;
  allFindings: WalkthroughFinding[];
  walkthroughSteps: Array<{
    id: string;
    stepNumber: number;
    title: string;
    personaReasoning: string | null;
    grounding: string | null;
    screenshotPath: string | null;
    pageUrl?: string | null;
    surface?: string | null;
  }>;
  runNumber: number | undefined;
  verdicts?: Array<{ question: string; rating: string; reasoning?: string }>;
  whatWorked: string[];
  openQuestions: string[];
}

export function WorkspacePrintDocument({
  walkthrough,
  allFindings,
  walkthroughSteps,
  runNumber,
  verdicts,
  whatWorked,
  openQuestions,
}: WorkspacePrintDocumentProps) {
  const scenario = walkthrough.scenario;
  const persona = walkthrough.persona;
  const personaBrief = scenario?.brief || walkthrough.promptText;

  return (
    <WalkthroughPrintDocument
      className="hidden print:block"
      scenarioName={scenario?.name ?? "Walkthrough"}
      scenarioNarrative={scenario?.narrative ?? personaBrief}
      persona={persona}
      walkthroughId={walkthrough.id}
      runNumber={runNumber}
      startedAt={walkthrough.startedAt}
      completedAt={walkthrough.completedAt}
      targetUrl={walkthrough.targetUrl}
      steps={walkthroughSteps.map((s) => ({
        id: s.id,
        stepNumber: s.stepNumber,
        action: s.title,
        screenTitle: s.surface,
        personaReasoning: s.personaReasoning,
        url: s.pageUrl,
      }))}
      findings={allFindings.map((f) => ({
        id: f.id,
        title: f.title || f.description || "Finding",
        type: f.type,
        severity: f.severity,
        uiFact: f.uiFact,
        consequence: f.consequence,
        recommendation: f.recommendation,
        walkthroughStepId: f.walkthroughStepId,
        stepNumber: f.stepNumber,
        targetBox: f.targetBox,
      }))}
      verdicts={verdicts}
      whatWorked={whatWorked}
      openQuestions={openQuestions}
    />
  );
}
